<div class="sh-page">
  <!-- 0. ANNOUNCEMENT TICKER -->
  <div class="sh-ticker" *ngIf="tickerVisible">
    <div class="sh-ticker-left">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"/></svg>
      <span>Announcements</span>
    </div>
    <div class="sh-ticker-track-wrap">
      <div class="sh-ticker-track">
        <span class="sh-ticker-item">
          <span class="sh-ti-badge sh-ti-badge--red">Live</span>
          Free CSSE Predictor
          <strong>Free 11+ CSSE Prediction to Predict your spot in Grammar School</strong>
          <a routerLink="/free-csse-predictor" class="sh-ti-link">Check Your Prediction →</a>
        </span>

        <span class="sh-ticker-item">
          <span class="sh-ti-badge sh-ti-badge--red">Live</span>
          Admission Open 2026-27
          <strong>KS1 • KS2 • 7+ • 11+ • 12+ • 13+ • KS3 • ISEB • GCSE • A-Level</strong>
          <a href="https://go.sehyog.co.uk/FreeDemoForm" class="sh-ti-link">Book a Free Demo →</a>
        </span>

        <span class="sh-ticker-sep">|</span>

        <span class="sh-ticker-item">
          <span class="sh-ti-badge sh-ti-badge--green">Open</span>
          11+ Admission Open
          <a routerLink="/11plus-admission" class="sh-ti-link">Enrol →</a>
        </span>

        <span class="sh-ticker-sep">|</span>

        <span class="sh-ticker-item">
          <span class="sh-ti-badge sh-ti-badge--green">Open</span>
          GCSE Admission Open
          <a routerLink="/gcse-admission" class="sh-ti-link">Enrol →</a>
        </span>
      </div>
    </div>
  </div>

  <!-- 0b. EXPERT TUITION STRAPLINE -->
  <!-- <div class="sh-strap">
    <div class="sh-container sh-strap-inner">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 2 3 3 6 3s6-1 6-3v-5" /></svg>
      <span class="sh-strap-text">
        Expert Tuition &amp; Mock Exams for
        <strong>KS1, KS2, 7+, 11+, 12+, 13+, KS3, ISEB, GCSE &amp; A-Level</strong>
        Students
      </span>
    </div>
  </div> -->

  <!-- 1. HERO SLIDER -->
  <section class="sh-cf-hero">
    <div class="sh-cf-stage">
      <button class="sh-cf-arrow sh-cf-arrow--prev" *ngIf="heroSlides.length > 1" (click)="heroPrev()" aria-label="Previous slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
      </button>

      <div class="sh-cf-track" #cfTrack
           (touchstart)="pauseHeroAutoplay()" (touchend)="resumeHeroAutoplay()"
           (mousedown)="pauseHeroAutoplay()" (mouseup)="resumeHeroAutoplay()">
        <article class="sh-cf-card" *ngFor="let slide of heroSlides; let i = index">
          <img [src]="slide.image || defaultHeroImage" [alt]="slide.title ? stripTags(slide.title) : 'Sehyog Academy'"
               [attr.loading]="i === 0 ? 'eager' : 'lazy'" [attr.fetchpriority]="i === 0 ? 'high' : null"
               decoding="async" (error)="onImgError($event)" />
          <div class="sh-cf-overlay">
            <span class="sh-cf-tag" *ngIf="slide.tag">{{ slide.tag }}</span>
            <h1 class="sh-cf-title" [innerHTML]="slide.title"></h1>
            <p class="sh-cf-desc" [innerHTML]="slide.description"></p>
            <div class="sh-cf-cta-row">
              <a href="https://go.sehyog.co.uk/FreeDemoForm" class="sh-cf-cta">
                Book a Free Demo
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
              </a>
              <button *ngIf="slide.button" class="sh-cf-cta-outline" (click)="onSlideButtonClick(i)">{{ slide.button }}</button>
            </div>
          </div>
        </article>
      </div>

      <button class="sh-cf-arrow sh-cf-arrow--next" *ngIf="heroSlides.length > 1" (click)="heroNext()" aria-label="Next slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 19l7-7-7-7" /></svg>
      </button>

      <div class="sh-cf-dots" *ngIf="heroSlides.length > 1">
        <button *ngFor="let slide of heroSlides; let i = index" class="sh-cf-dot"
                [class.sh-cf-dot--on]="i === heroActiveIndex"
                (click)="goToHeroDot(i)" [attr.aria-label]="'Go to slide ' + (i + 1)"></button>
      </div>
    </div>
  </section>

  <!-- 2. STATS + OFFERS -->
  <section class="sh-so">
    <div class="sh-container">
      <div class="sh-so-grid">
        <div class="sh-so-stat"><span class="sh-so-num">10K+</span><span class="sh-so-label">Students Supported</span></div>
        <div class="sh-so-stat"><span class="sh-so-num">15+</span><span class="sh-so-label">Subjects</span></div>
        <div class="sh-so-stat"><span class="sh-so-num">25+</span><span class="sh-so-label">Qualified Tutors</span></div>
        <div class="sh-so-stat"><span class="sh-so-num">10+</span><span class="sh-so-label">Years Experience</span></div>
      </div>
      <div class="sh-so-offer">
        <div class="sh-so-offer-left">
          <span class="sh-so-offer-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" /><path d="M12 22V7" /><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" /><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" /></svg>
          </span>
          <p class="sh-so-offer-title">Special Offers &amp; Discounts</p>
        </div>
        <a routerLink="/offer-free-resources" class="sh-so-offer-btn">
          Save Up To 50%
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
        </a>
      </div>
    </div>
  </section>

  <!-- 3b. GRAMMAR SCHOOLS MARQUEE -->
  <div class="sh-marquee-section">
    <div class="sh-marquee-label">Our students have secured places at</div>
    <div class="sh-marquee-track-wrap">
      <div class="sh-marquee-track">
        <div class="sh-school-chip"><img src="https://www.ichs.org.uk/images/logo.svg" alt="Ilford County High School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Ilford County High</span></div>
        <div class="sh-school-chip"><img src="https://www.cchs.co.uk/wp-content/themes/schoolcms/images/logo.svg" alt="Chelmsford County High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Chelmsford County High for Girls (CCHS)</span></div>
        <div class="sh-school-chip"><img src="https://qes-sz.b-cdn.net/2025/02/qes_logo.png" alt="Queen Elizabeth's School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Queen Elizabeth's Boys</span></div>
        <div class="sh-school-chip"><img src="https://www.hbschool.org.uk/wp-content/themes/hbs/build/img/hbs-logo-v2.svg" alt="Henrietta Barnett School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Henrietta Barnett</span></div>
        <div class="sh-school-chip"><img src="https://www.woodford.redbridge.sch.uk/_site/images/design/logo.svg" alt="Woodford County High School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Woodford County High</span></div>
        <div class="sh-school-chip"><img src="https://www.shsg.org/wp-content/uploads/2021/09/A4-MASTER-SCHOOL-CREST-RGB.png" alt="Southend High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Southend High for Girls</span></div>
        <div class="sh-school-chip"><img src="https://www.bexleygs.co.uk/_site/images/design/logo_new.png" alt="Bexley Grammar School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Bexley Grammar</span></div>
        <div class="sh-school-chip"><img src="https://www.ags.bucks.sch.uk/wp-content/uploads/2020/11/LOGO_HORIZONTAL_REVERSED.png" alt="Aylesbury Grammar School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Aylesbury Grammar</span></div>
        <div class="sh-school-chip"><img src="https://www.kendrick.reading.sch.uk/_site/images/design/logo.svg" alt="Kendrick School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Kendrick School</span></div>
        <div class="sh-school-chip"><img src="https://www.st-bernards.slough.sch.uk/images/logo_light.png" alt="St. Bernard's Catholic High School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>St. Bernard's Catholic High School</span></div>
        <div class="sh-school-chip"><img src="https://www.woodford.redbridge.sch.uk/_site/images/design/logo.svg" alt="Woodford County High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Woodford County High for Girls</span></div>
        <div class="sh-school-chip"><img src="https://www.nonsuchschool.org/_site/images/design/logo.png" alt="Nonsuch High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Nonsuch High for Girls</span></div>
        <!-- Duplicate set for seamless loop -->
        <div class="sh-school-chip"><img src="https://www.ichs.org.uk/images/logo.svg" alt="Ilford County High School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Ilford County High</span></div>
        <div class="sh-school-chip"><img src="https://www.cchs.co.uk/wp-content/themes/schoolcms/images/logo.svg" alt="Chelmsford County High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Chelmsford County High for Girls (CCHS)</span></div>
        <div class="sh-school-chip"><img src="https://qes-sz.b-cdn.net/2025/02/qes_logo.png" alt="Queen Elizabeth's School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Queen Elizabeth's Boys</span></div>
        <div class="sh-school-chip"><img src="https://www.hbschool.org.uk/wp-content/themes/hbs/build/img/hbs-logo-v2.svg" alt="Henrietta Barnett School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Henrietta Barnett</span></div>
        <div class="sh-school-chip"><img src="https://www.woodford.redbridge.sch.uk/_site/images/design/logo.svg" alt="Woodford County High School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Woodford County High</span></div>
        <div class="sh-school-chip"><img src="https://www.shsg.org/wp-content/uploads/2021/09/A4-MASTER-SCHOOL-CREST-RGB.png" alt="Southend High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Southend High for Girls</span></div>
        <div class="sh-school-chip"><img src="https://www.bexleygs.co.uk/_site/images/design/logo_new.png" alt="Bexley Grammar School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Bexley Grammar</span></div>
        <div class="sh-school-chip"><img src="https://www.ags.bucks.sch.uk/wp-content/uploads/2020/11/LOGO_HORIZONTAL_REVERSED.png" alt="Aylesbury Grammar School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Aylesbury Grammar</span></div>
        <div class="sh-school-chip"><img src="https://www.kendrick.reading.sch.uk/_site/images/design/logo.svg" alt="Kendrick School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Kendrick School</span></div>
        <div class="sh-school-chip"><img src="https://www.st-bernards.slough.sch.uk/images/logo_light.png" alt="St. Bernard's Catholic High School" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>St. Bernard's Catholic High School</span></div>
        <div class="sh-school-chip"><img src="https://www.woodford.redbridge.sch.uk/_site/images/design/logo.svg" alt="Woodford County High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Woodford County High for Girls</span></div>
        <div class="sh-school-chip"><img src="https://www.nonsuchschool.org/_site/images/design/logo.png" alt="Nonsuch High School for Girls" referrerpolicy="no-referrer" loading="lazy" decoding="async" (error)="onImgError($event)" /><span>Nonsuch High for Girls</span></div>
      </div>
    </div>
  </div>

  <!-- 3. WHAT WE OFFER -->
  <section class="sh-explore">
    <div class="sh-container">
      <div class="sh-explore-header">
        <div>
          <p class="sh-eyebrow">What We Offer: Expert Tuition &amp; Mock Exams</p>
        </div>
        <a href="https://go.sehyog.co.uk/FreeDemoForm" class="sh-explore-link">Book a Free Demo →</a>
      </div>
      <div class="sh-explore-grid">
        <a class="sh-exp-card" routerLink="/freedemo">
          <img src="https://images.pexels.com/photos/8121106/pexels-photo-8121106.jpeg?auto=compress&cs=tinysrgb&w=600" alt="11plus Tutoring" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge">Popular</span><h4>KS1, KS2, 7+ Tutoring</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/11Plus-classes">
          <img src="https://images.pexels.com/photos/5311404/pexels-photo-5311404.jpeg?auto=compress&cs=tinysrgb&w=600" alt="GCSE Tutoring" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge">Popular</span><h4>11+ 12+ 13+ Tutoring</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/gcse-classes">
          <img src="https://images.pexels.com/photos/5212319/pexels-photo-5212319.jpeg?auto=compress&cs=tinysrgb&w=600" alt="11+ Intensive Crash Course" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--gd">Popular</span><h4>KS3, GSCE Tutoring</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/freedemo">
          <img src="https://images.pexels.com/photos/35745619/pexels-photo-35745619.jpeg?auto=compress&cs=tinysrgb&w=600" alt="11+ Intensive Crash Course" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--gd">Popular</span><h4>ISEB Tutoring</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/11plus-mock-test">
          <img src="https://images.pexels.com/photos/6684265/pexels-photo-6684265.jpeg?auto=compress&cs=tinysrgb&w=600" alt="11plus Mock Exams" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--cy">Test Ready</span><h4>11+ Mock Exams</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/11plus-topic-test">
          <img src="https://images.pexels.com/photos/3874366/pexels-photo-3874366.jpeg?auto=compress&cs=tinysrgb&w=600" alt="11plus Mock Exams" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--cy">Test Ready</span><h4>11+ Topic Test</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/gcse-mock-test">
          <img src="https://images.pexels.com/photos/6929185/pexels-photo-6929185.jpeg?auto=compress&cs=tinysrgb&w=600" alt="GCSE Mock Exams" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--cy">Test Ready</span><h4>GCSE Mock Exams</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/gcse-mock-test">
          <img src="https://images.pexels.com/photos/6683441/pexels-photo-6683441.jpeg?auto=compress&cs=tinysrgb&w=600" alt="GCSE Mock Exams" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--cy">Test Ready</span><h4>GCSE Mini Mock</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/ks3-mock-test">
          <img src="https://images.pexels.com/photos/7972487/pexels-photo-7972487.jpeg?auto=compress&cs=tinysrgb&w=600" alt="11+ Consortium Prep" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--gd">Exam Ready</span><h4>KS3 Mock Test</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/year-4-mock-test">
          <img src="https://images.pexels.com/photos/8423093/pexels-photo-8423093.jpeg" alt="Summer Intensive" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge">Test Ready</span><h4>Y4 Topic Test</h4></div>
        </a>
        <a class="sh-exp-card" routerLink="/11plus-HelpClub">
          <img src="https://www.how2become.com/wp-content/uploads/2024/12/11-plus-practice-questions.jpeg" alt="11+ Help Club" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-exp-overlay"><span class="sh-exp-badge sh-exp-badge--cy">Community</span><h4>Free 11+ Help Club</h4></div>
        </a>
      </div>
    </div>
  </section>

  <!-- STUDENT CORNER -->
  <section class="sh-sc">
    <div class="sh-container">
      <div class="sh-sc-header">
        <p class="sh-eyebrow">Student Corner</p>
        <p class="sh-sc-sub">Real students, real results — meet a few of the faces behind our success stories.</p>
      </div>

      <div class="sh-sc-carousel">
        <button class="sh-sc-arrow sh-sc-arrow--prev" *ngIf="students.length > 1" (click)="scPrev()" aria-label="Previous student">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
        </button>

        <div class="sh-sc-track" #scTrack>
          <div class="sh-sc-spacer" aria-hidden="true"></div>

          <div class="sh-sc-slide" *ngFor="let student of students; let i = index"
               [class.sh-sc-slide--active]="i === scActiveIndex">
            <article class="sh-sc-card">
              <div class="sh-sc-media">
                <img [src]="student.photo" [alt]="student.name || 'Sehyog student'" loading="lazy" decoding="async" (error)="onImgError($event)" />
                <div class="sh-sc-badge" *ngIf="student.verified">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                </div>
              </div>
              <div class="sh-sc-body">
                <p class="sh-sc-hello">Say Hello</p>
                <h3 class="sh-sc-name" *ngIf="student.name">{{ student.name }}</h3>
                <p class="sh-sc-story">{{ student.story }}</p>
                <h4 class="sh-sc-why">{{ student.intro }}</h4>
                <ul class="sh-sc-checklist">
                  <li *ngFor="let point of student.points">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                    <span>{{ point }}</span>
                  </li>
                </ul>
              </div>
            </article>
          </div>

          <div class="sh-sc-spacer" aria-hidden="true"></div>
        </div>

        <button class="sh-sc-arrow sh-sc-arrow--next" *ngIf="students.length > 1" (click)="scNext()" aria-label="Next student">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 19l7-7-7-7" /></svg>
        </button>
      </div>

      <div class="sh-sc-dots" *ngIf="students.length > 1">
        <button *ngFor="let student of students; let i = index" class="sh-sc-dot"
                [class.sh-sc-dot--on]="i === scActiveIndex"
                (click)="goToScDot(i)" [attr.aria-label]="'View student ' + (i + 1)"></button>
      </div>
    </div>
  </section>

  <!-- 4b. VIDEO TESTIMONIALS -->
  <section class="sh-testi">
    <div class="sh-container">
      <div class="sh-testi-header">
        <p class="sh-eyebrow sh-eyebrow--light">Success Stories</p>
      </div>
      <div class="sh-video-wrap">
        <div class="sh-video-track" [style.transform]="transformStyle">
          <div class="sh-video-item" *ngFor="let video of videoItems"
               [style.flex]="'0 0 ' + (100 / videosPerView) + '%'"
               [style.max-width]="(100 / videosPerView) + '%'">
            <div class="sh-video-frame">
              <iframe *ngIf="playingVideoId === video.id" [src]="video.embed"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
              <button *ngIf="playingVideoId !== video.id" type="button" class="sh-video-thumb"
                      (click)="playVideo(video.id)" aria-label="Play student testimonial video">
                <img [src]="video.thumb" alt="Student testimonial video" loading="lazy" decoding="async" (error)="onImgError($event)" />
                <span class="sh-video-play" aria-hidden="true">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="sh-video-nav">
        <button class="sh-varr" (click)="slideVideo(-1)" [disabled]="currentVSlide === 0">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
        </button>
        <div class="sh-vdots">
          <button class="sh-vdot" *ngFor="let dot of dots; let i = index"
                  [class.sh-vdot--on]="i === currentVSlide" (click)="goToSlide(i)"></button>
        </div>
        <button class="sh-varr" (click)="slideVideo(1)" [disabled]="currentVSlide >= totalSlides - 1">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 19l7-7-7-7" /></svg>
        </button>
      </div>
      <div class="sh-testi-more">
        <a href="/sehyog/video-gallery" class="sh-btn-outline sh-testi-more-btn">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          View All Testimonials
        </a>
      </div>
    </div>
  </section>

  <!-- 6. UPCOMING SESSIONS -->
  <section class="sh-upcoming" *ngIf="images?.length > 0">
    <div class="sh-container">
      <div class="sh-upcoming-header">
        <div>
          <p class="sh-eyebrow sh-eyebrow--light">Upcoming Sessions</p>
        </div>
        <a routerLink="/11plus-mock-test" class="sh-upcoming-all">View All →</a>
      </div>
      <div class="sh-upcoming-grid">
        <div class="sh-up-card" *ngFor="let image of images | slice: 0 : 4"
             [routerLink]="['/11plus-help-club/category/', image.category_slug, image.test_slug]">
          <div class="sh-up-img">
            <img [src]="image?.test_image" [alt]="image?.test_name" loading="lazy" decoding="async" (error)="onImgError($event)" />
          </div>
          <div class="sh-up-body">
            <div class="sh-up-date" *ngIf="image?.test_date">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
              {{ image.test_date }}
            </div>
            <h3 class="sh-up-title">{{ image?.test_name }}</h3>
            <div class="sh-up-loc">
              <span class="sh-up-badge" *ngIf="image?.test_location == ''">Online</span>
              <span class="sh-up-badge sh-up-badge--f2f" *ngIf="image?.test_location != ''">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
                {{ image?.test_location }}
              </span>
            </div>
            <a class="sh-up-btn" [routerLink]="['/11plus-help-club/category/', image.category_slug, image.test_slug]">Book →</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- USP SECTION -->
  <section class="sh-usp">
    <div class="sh-container">
      <div class="sh-usp-header">
        <div class="sh-usp-eyebrow">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
          WHAT SETS US APART
        </div>
        <p class="sh-usp-sub">Every student deserves more than just teaching. Here's what comes standard with every Sehyog programme.</p>
      </div>
      <div class="sh-usp-grid">
        <div class="sh-usp-card">
          <div class="sh-usp-icon sh-usp-icon--green">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
          </div>
          <div class="sh-usp-card-num">01</div>
          <h3 class="sh-usp-card-title">10+ Years of Proven Excellence</h3>
          <p class="sh-usp-card-text">With over 10 years of experience and 10,000+ students taught, we bring trusted expertise to every learner. Our UK board expert teachers understand the curriculum inside out, delivering personalised guidance that builds confidence, strengthens skills, and prepares students for success.</p>
          <div class="sh-usp-tags">
            <span class="sh-usp-tag">F2F &amp; Online</span>
            <span class="sh-usp-tag sh-usp-tag--g">8 Centres</span>
          </div>
        </div>

        <div class="sh-usp-card">
          <div class="sh-usp-icon sh-usp-icon--cyan">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
          </div>
          <div class="sh-usp-card-num">02</div>
          <h3 class="sh-usp-card-title">Student 360</h3>
          <p class="sh-usp-card-text">Student 360 gives you a complete view of your child’s learning journey. Track daily progress, strengths, and areas that need improvement. Get instant tutor feedback after every class for clear, timely insights. Stay aligned through regular parent–teacher reviews and personalised guidance.</p>
          <div class="sh-usp-tags">
            <span class="sh-usp-tag">Post-Class</span>
            <span class="sh-usp-tag sh-usp-tag--g">Parent-Facing</span>
          </div>
        </div>

        <div class="sh-usp-card">
          <div class="sh-usp-icon sh-usp-icon--gold">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>
          </div>
          <div class="sh-usp-card-num">03</div>
          <h3 class="sh-usp-card-title">Prep Work &amp; Consolidation Resources</h3>
          <p class="sh-usp-card-text">Students receive targeted prep work before every class to prime them for the lesson, and consolidation resources after to reinforce learning — making every session count twice over.</p>
          <div class="sh-usp-tags">
            <span class="sh-usp-tag">Pre-Class</span>
            <span class="sh-usp-tag sh-usp-tag--g">Post-Class</span>
          </div>
        </div>

        <div class="sh-usp-card">
          <div class="sh-usp-icon sh-usp-icon--navy">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>
          </div>
          <div class="sh-usp-card-num">04</div>
          <h3 class="sh-usp-card-title">Real Exam-Condition Mock Tests &amp; Result Analysis Report (RAR)</h3>
          <p class="sh-usp-card-text">Real mock tests under timed, invigilated conditions - face-to-face or online. After every test, your child receives a detailed RAR with Standardised Age Score (SAS), subject-by- subject breakdown and a benchmarked comparison against our full cohort of 150-250+ students.</p>
          <div class="sh-usp-tags">
            <span class="sh-usp-tag">F2F &amp; Online</span>
            <span class="sh-usp-tag">After Every Mock</span>
            <span class="sh-usp-tag sh-usp-tag--g">Cohort Benchmarked</span>
          </div>
        </div>

        <div class="sh-usp-card">
          <div class="sh-usp-icon sh-usp-icon--purple">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
          </div>
          <div class="sh-usp-card-num">05</div>
          <h3 class="sh-usp-card-title">1:1 Support Clinics &amp; Targeted Intervention</h3>
          <p class="sh-usp-card-text">Every student has access to one-on-one support clinics with experienced &amp; UK board expert teachers — the chance to go back, understand mistakes and build genuine confidence through targeted intervention.</p>
          <div class="sh-usp-tags">
            <span class="sh-usp-tag">1:1 Support</span>
            <span class="sh-usp-tag sh-usp-tag--g">Post-Mock</span>
          </div>
        </div>

        <div class="sh-usp-card sh-usp-card--cta">
          <div class="sh-usp-cta-inner">
            <div class="sh-usp-icon sh-usp-icon--navy">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6" /><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" /></svg>
            </div>
            <div class="sh-usp-card-num">06</div>
            <h3 class="sh-usp-card-title">Parent Progress Reviews &amp; Parents' Evenings</h3>
            <p class="sh-usp-card-text">Regular structured parents' evenings keep families fully informed, set targets and ensure teaching strategy adapts to each child's evolving needs throughout the year.</p>
            <div class="sh-usp-tags">
              <span class="sh-usp-tag">Regular</span>
              <span class="sh-usp-tag sh-usp-tag--g">Goal-Setting</span>
            </div>
            <a href="https://go.sehyog.co.uk/FreeDemoForm" class="sh-btn-gold" style="margin-top: 24px; display: inline-flex">
              Experience It Free
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 10. WHO WE ARE -->
  <section class="sh-about">
    <div class="sh-container">
      <div class="sh-about-inner">
        <div class="sh-about-imgwrap">
          <img src="https://images.pexels.com/photos/40456024/pexels-photo-40456024.jpeg" alt="SEHYOG Academy" loading="lazy" decoding="async" (error)="onImgError($event)" />
          <div class="sh-about-badge">
            <span class="sh-about-badge-num">10+</span>
            <span class="sh-about-badge-txt">Years of Excellence</span>
          </div>
        </div>
        <div class="sh-about-content">
          <p class="sh-eyebrow">Who We Are</p>
          <p class="sh-about-text">Founded in East London in 2014 as a small 11+ help group, SEHYOG has grown into one of the UK's leading tutoring academies — now supporting students from Year 3 to Year 13 across the UK and internationally.</p>
          <div class="sh-about-pts">
            <span class="sh-about-pt">11+, GCSE and A-Level across all major UK exam boards</span>
            <span class="sh-about-pt">GL, CSSE, AQA, OCR, Edexcel, CAIE and more</span>
            <span class="sh-about-pt">10,000+ students supported since 2014</span>
            <span class="sh-about-pt">Face-to-face and online sessions available</span>
          </div>
          <a href="https://go.sehyog.co.uk/FreeDemoForm" class="sh-btn-gold">
            Book a Free Demo
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
